"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaSettings = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const CommonProperties_1 = __importDefault(require("../../properties/CommonProperties"));
const FormSettingsContext_1 = require("../../../context/FormSettingsContext");
const transformresponsedata_1 = require("../../../utils/transformresponsedata");
const Mapper_1 = require("../../../utils/Mapper");
const icons_1 = require("../../common/icons");
const NoForms_1 = __importDefault(require("../../NoForms"));
const SchemaSettings = ({}) => {
    const [data, setData] = (0, react_1.useState)([]);
    const { currentSchema, selectedForm, setCurrentSchema } = (0, FormSettingsContext_1.useFormSetting)();
    console.log("currentSchema", currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs);
    const currentSchemaChanged = (newSchema) => {
        const transformedData = (0, transformresponsedata_1.reverseTransformData)(newSchema, Mapper_1.FORM_DATA_MAPPER);
        console.log("transformedData reverse", transformedData);
        setCurrentSchema((prev) => (Object.assign(Object.assign({}, prev), { inputs: transformedData })));
    };
    const handleFieldTypeChange = (index, newFieldType) => {
        const updatedData = [...data];
        updatedData[index] = newFieldType;
        setData(updatedData);
    };
    (0, react_1.useEffect)(() => {
        if (currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs) {
            let newSchema = currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs;
            if (selectedForm) {
                newSchema = newSchema.filter((item) => item.formInputId);
            }
            const transformedData = (0, transformresponsedata_1.transformData)(newSchema, Mapper_1.FORM_DATA_MAPPER);
            setData(transformedData);
        }
        // const transformedData = transformData(input, FORM_DATA_MAPPER);
        // setData(transformedData.map((item: any) => ({ ...item, isVisible: true })));
    }, [currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs]);
    console.log("data", data);
    return data.length === 0 ? ((0, jsx_runtime_1.jsx)(NoForms_1.default, { icon: (0, jsx_runtime_1.jsx)(icons_1.PropertiesLogoIcon, { width: 48, height: 48 }), title: "No Field Added", description: "No Field Added\nDrag and drop fields in canvas to start building your form. This space will show your form field properties as you design." })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [data.map((fieldType) => ((0, jsx_runtime_1.jsx)(CommonProperties_1.default, { fieldType: fieldType, setFieldType: (newFieldType) => handleFieldTypeChange(data.findIndex((field) => field.id === fieldType.id), newFieldType) }, fieldType.id))), (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", color: "primary", size: "small", sx: { mt: 2, width: "100%" }, onClick: () => currentSchemaChanged(data), children: "Apply" })] }));
};
exports.SchemaSettings = SchemaSettings;
